import { listGender } from "data/list";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, AUTO_COMPLETE } = FIELD_TYPE;

export const DoctorOptions = [
  { value: "Nguyễn Thị Mai Phương" },
  { value: "Đàm Văn Quý" },
  { value: "Nguyễn Thị Thu Hương" },
  { value: "Đỗ Thị Liên" },
  { value: "Hoàng Thị Hạnh" },
  { value: "Nguyễn Lê Ngọc Khanh" },
  { value: "Nguyễn Thị Phương" },
  { value: "Hà Duy Nam" },
  { value: "Dương Thị Kiều Anh" },
  { value: "Nguyễn Quỳnh Chi" },
  { value: "Trần Thị Thanh Huyền" },
  { value: "Trần Thị Vân Anh" },
  { value: "Nguyễn Thị Thanh Hằng" },
  { value: "Đỗ Thị Dịu" },
  { value: "Cao Thị Nhật Lệ" },
  { value: "Lê Thị Thu Lan" },
  { value: "Dương Thị Kiều Nga" },
  { value: "Nguyễn Thị Minh Ánh" },
  { value: "Vũ Thị Hân" },
  { value: "Nguyễn Thị Thương" },
  { value: "Phạm Thị Hương Giang" },
  { value: "Nguyễn Thị Thanh" },
  { value: "Đỗ Thị Tú Linh" },
  { value: "Đàm Thị Nhài" },
  { value: "Trần Thị Hằng" },
];
const fields: DataFormField[] = [
  {
    type: DATE,
    label: "Ngày tạo",
    name: "ngayTao",
    optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    disableDate: true,
    disable: true,
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "dienThoai",
    disable: true,
    placeholder: "",
  },
  {
    type: SELECT,
    label: "Loại KCB",
    name: "loaiKCB",
    disable: true,
    options: JSON.parse(localStorage.getItem("loaiKCB")),
    placeholder: "",
  },
  {
    type: INPUT,
    label: "Thân nhân",
    name: "thanNhan",
    placeholder: "",
    disable: true,
  },
  {
    type: AUTO_COMPLETE,
    label: "Người đọc KQ",
    name: "nguoiDocKetQua",
    options: DoctorOptions,
  },
  {
    type: AUTO_COMPLETE,
    label: "BS chuyên khoa",
    name: "bacSyChuyenKhoa",
    options: DoctorOptions,
  },
  {
    type: SELECT,
    label: "Trạng thái ĐT",
    name: "trangThai",
    options: JSON.parse(localStorage.getItem("TTPhieu")),
    disable: true,
    placeholder: "",
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "diaChiTongHop",
    placeholder: "",
    disable: true,
    css: { xl: 16, lg: 12, md: 24, sm: 12 },
    labelCol: { xl: 3, lg: 8, md: 8, sm: 12 },
    wrapperCol: { xl: 21, lg: 16, md: 16, sm: 12 },
  },
  {
    type: INPUT,
    label: "Lý do khám",
    css: {
      xl: 12,
      lg: 12,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 4 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 20 },
    name: "lyDoKham",
    disable: true,
    placeholder: "",
  },
  {
    type: DATE,
    label: "TG chỉ định",
    css: {
      xl: 12,
      lg: 12,
      md: 24,
      sm: 24,
      xs: 24,
    },
    disable: true,
    labelCol: { xs: 10, md: 8, lg: 4, xl: 4 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 20 },
    name: "thoiGianChiDinh",
    optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
  },
];
export { fields };
